<td [attr.colspan]="colspan">
  <ix-table2-expandable-row>
    <button mat-button [ixTest]="[group.group, 'members']" (click)="openGroupMembersForm()">
      <ix-icon name="people"></ix-icon>
      <span>{{ 'Members' | translate }}</span>
    </button>

    <button
      *ngIf="!group.builtin"
      mat-button
      [ixTest]="[group.group, 'edit']"
      (click)="doEdit(group)"
    >
      <ix-icon name="edit"></ix-icon>
      <span>{{ 'Edit' | translate }}</span>
    </button>

    <ng-container *ixRequiresRoles="[Role.AccountWrite]">
      <button
        *ngIf="!group.builtin"
        mat-button
        [ixTest]="[group.group, 'delete']"
        (click)="doDelete(group)"
      >
        <ix-icon name="delete"></ix-icon>
        <span>{{ 'Delete' | translate }}</span>
      </button>
    </ng-container>
  </ix-table2-expandable-row>
</td>
